import * as React from 'react'
import UploadPage from './UploadPage'
import UploadFilesAdmin from './UploadFilesAdmin'
import { ApplicationState } from '../../../reducers'
import Auth, { CognitoUser } from '@aws-amplify/auth'
import { CognitoUserAttribute } from 'amazon-cognito-identity-js'
import bind from 'bind-decorator'
import { connect } from 'react-redux'
import { isUserAdmin } from '../../../utilities'

export type File = {
    id: string
    userId: string
    name: string
    url: string
    uploadedAt: number
}

type Props = {
    isLoggedIn: boolean
}

type State = {
    currentUser: CognitoUser | undefined
    username: string
    isAdmin: boolean
}

class UploadPageLoad extends React.Component<Props> {
    readonly state: State = {
        currentUser: undefined,
        username: '',
        isAdmin: false,
    }

    componentDidMount() {
        this.prepareUser()
    }

    componentDidUpdate(prevProps: Props) {
        if (!prevProps.isLoggedIn && this.props.isLoggedIn) {
            this.prepareUser()
        }
    }

    getAttributeByName(name: string, attributes: CognitoUserAttribute[]) {
        const attribute = attributes.find(attribute => attribute.getName() === name)

        return attribute ? attribute.getValue() : ''
    }

    @bind
    async prepareUser() {
        if (!this.props.isLoggedIn) {
            return 'User is not logged in.'
        }

        const user = await Auth.currentAuthenticatedUser()

        if (!user || !(user as CognitoUser).getUserAttributes) {
            return 'Have issues finding the user.'
        }

        const isAdmin = await isUserAdmin()

        const attributes = await new Promise<CognitoUserAttribute[]>((resolve, reject) => {
            (user as CognitoUser).getUserAttributes((err, attributes) => {
                if (err) {
                    reject(err)
                    return
                }

                resolve(attributes)
            })
        })

        this.setState({
            isAdmin,
            currentUser : user,
            username: this.getAttributeByName('sub', attributes),
        })
    }

    render() {
        const {
            currentUser,
            username,
            isAdmin,
        } = this.state

        return (
        <>
            {currentUser !== undefined && username !== '' ?
                isAdmin ?
                    <UploadFilesAdmin /> :
                    <UploadPage
                        currentUser={currentUser}
                        username={username}
                    />
                : ''
            }
        </>
        )
    }
}

const mapStateToProps = (state: ApplicationState): Props => ({
    isLoggedIn: state.account.loggedIn,
})

const UploadPageWithData = connect(mapStateToProps)(UploadPageLoad)

export { UploadPageWithData }
